import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//

import request from "@/utils/request";

// 获取表头
function getTableHead(data) {
  return request({
    url: "/public/sqlTemplate/queryFields?templateCode=" + data,
    method: "get",
    data: data
  });
}
export default {
  name: 'Oporderby',
  components: {},
  props: {
    templateId: {
      type: String,
      required: true,
      default: ""
    }
  },
  data: function data() {
    return {
      orderBys: []
    };
  },
  computed: {},
  created: function created() {
    this.getData();
  },
  methods: {
    inOrder: function inOrder(item) {
      if (item.orderBy === '') {
        this.$set(item, 'orderBy', 'asc');
      } else if (item.orderBy === 'asc') {
        this.$set(item, 'orderBy', 'desc');
      } else if (item.orderBy === 'desc') {
        this.$set(item, 'orderBy', '');
      }
      var selected = this.orderBys.filter(function (item) {
        if (item.orderBy !== '') {
          return item;
        }
      });
      var orderBy = "order by";
      selected && selected.length > 0 && selected.forEach(function (item, index) {
        orderBy = " ".concat(orderBy).concat(index > 0 && index < selected.length ? ',' : '', " ").concat(item.orderCode, " ").concat(item.orderBy);
      });
      if (selected.length < 1) {
        orderBy = "";
      }
      this.$emit("callbackOrderBy", orderBy);
      console.log(orderBy);
    },
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.templateId) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return getTableHead(this.templateId);
            case 3:
              result = _context.sent;
              if (result.code === 200) {
                result.data.orderBys.forEach(function (item) {
                  item.orderBy = '';
                });
                this.orderBys = result.data.orderBys;
              } else {
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
  }
};